import { gql } from '@apollo/client'

export const Mutation = gql`
  mutation DeleteMaintenanceTypeTask($companyId: ID!, $id: ID!) {
    deleteMaintenanceTypeTask(companyId: $companyId, id: $id) {
      maintenanceTypeTask {
        id
      }
      errors {
        path
        message
      }
    }
  }
`
